import { render, staticRenderFns } from "./CvRelocateRemote.vue?vue&type=template&id=4c474bb4&scoped=true"
import script from "./CvRelocateRemote.vue?vue&type=script&lang=js"
export * from "./CvRelocateRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c474bb4",
  null
  
)

export default component.exports